"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BHGModal = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactModal = _interopRequireDefault(require("react-modal"));

require("./Modal.scss");

var BHGModal = function BHGModal(props) {
  var isOpen = props.isOpen,
      onRequestClose = props.onRequestClose,
      className = props.className,
      overlayClassName = props.overlayClassName,
      contentLabel = props.contentLabel,
      children = props.children;

  _reactModal.default.setAppElement('#root');

  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_reactModal.default, {
    isOpen: isOpen,
    onRequestClose: onRequestClose,
    className: "bhg-modal " + (className ? className : ""),
    overlayClassName: "bhg-modal-overlay " + (overlayClassName ? overlayClassName : ""),
    contentLabel: contentLabel
  }, children));
};

exports.BHGModal = BHGModal;
BHGModal.defaultProps = {
  isOpen: false,
  onRequestClose: function onRequestClose() {},
  className: "",
  overlayClassName: "",
  contentLabel: "",
  children: null
};